import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import StylistPreview from './index';

const StylistPreviewWithSlug = () => {
  const { shareCode } = useLocalSearchParams();

  return <StylistPreview shareCode={shareCode as string} />;
};

export default StylistPreviewWithSlug;
